import { createContext, useContext, useState, ReactNode } from 'react';

interface EvaluationContextType {
  isFreeTrialMode: boolean;
  startFreeTrial: () => void;
  endFreeTrial: () => void;
}

const EvaluationContext = createContext<EvaluationContextType | undefined>(undefined);

export const EvaluationProvider = ({ children }: { children: ReactNode }) => {
  const [isFreeTrialMode, setIsFreeTrialMode] = useState(false);

  const startFreeTrial = () => {
    setIsFreeTrialMode(true);
  };

  const endFreeTrial = () => {
    setIsFreeTrialMode(false);
  };

  return (
    <EvaluationContext.Provider value={{ isFreeTrialMode, startFreeTrial, endFreeTrial }}>
      {children}
    </EvaluationContext.Provider>
  );
};

export const useEvaluation = () => {
  const context = useContext(EvaluationContext);
  if (!context) {
    throw new Error('useEvaluation must be used within EvaluationProvider');
  }
  return context;
};
